export class ListEffectiveTagsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tags",
            "baseName": "tags",
            "type": "Array<DataCatalogEffectiveTag>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListEffectiveTagsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
